
































import { defineComponent, ref, watch } from '@vue/composition-api';
import { debounce } from '@/bundles/App/helpers';
import { useActivityGroup } from '@/bundles/ActivityGroup/composables/useActivityGroup';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';
import { useWeeklyChallenge } from '@/bundles/ActivityGroup/composables/useWeeklyChallenge';

export default defineComponent({
  name: 'LoadWeeklyChallengesForm',
  emits: ['list:refresh'],

  setup(_, {emit}) {
    const {loading, weeklyChallenges, fetchWeeklyChallenges: fetch} = useWeeklyChallenge();

    const keyword = ref('');
    const selected = ref(null);

    function keywordSearch() {
      if (!keyword.value?.length) {
        return fetch({});
      }
      fetch({keyword: keyword.value});
    }

    const searchWrapper = debounce(keywordSearch, 500);
    watch(keyword, () => {
      searchWrapper();
    });

    const {addToGroup, addToGroupLoading} = useActivityGroup();

    async function submitEventHandler() {
      if (!selected.value) {
        return;
      }
      await addToGroup(ActivityGroupType.weekly_challenge, {record_id: selected.value!});
      clearForm();
      emit('list:refresh');
    }

    function clearForm() {
      selected.value = null;
      keyword.value = '';
    }

    return {
      keyword,
      selected,
      weeklyChallenges,
      addToGroupLoading,
      loading,
      submitEventHandler,
    };
  },
});
